import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import * as Const from "@utils/Const";
export default function ProductTree(props) {
    const { menu, item, setItem } = props;
    const handleView = (e, val) => {
        setItem(Object.assign(Object.assign({}, item), { depth2: val, type: Const.TYPE_L }));
    };
    return (_jsx(_Fragment, { children: _jsxs("aside", Object.assign({ className: "product-list" }, { children: [_jsx("h2", Object.assign({ className: "menu-title" }, { children: "\uC81C\uD488 \uBAA9\uB85D" })), _jsx("ul", { children: menu.map((items) => (_jsx("li", Object.assign({ onClick: (e) => handleView(e, items) }, { children: items.menuName }), items.menuId))) })] })) }));
}
